__turbopack_context__.v({
  "breadcrumbContainer": "TopNavigation-module__Tlm5cW__breadcrumbContainer",
  "breadcrumbEnter": "TopNavigation-module__Tlm5cW__breadcrumbEnter",
  "breadcrumbExit": "TopNavigation-module__Tlm5cW__breadcrumbExit",
  "breadcrumbItem": "TopNavigation-module__Tlm5cW__breadcrumbItem",
  "delay0": "TopNavigation-module__Tlm5cW__delay0",
  "delay1": "TopNavigation-module__Tlm5cW__delay1",
  "delay2": "TopNavigation-module__Tlm5cW__delay2",
  "delay3": "TopNavigation-module__Tlm5cW__delay3",
  "delay4": "TopNavigation-module__Tlm5cW__delay4",
  "delay5": "TopNavigation-module__Tlm5cW__delay5",
  "fadeOut": "TopNavigation-module__Tlm5cW__fadeOut",
  "logoAnimation": "TopNavigation-module__Tlm5cW__logoAnimation",
  "navAnimation": "TopNavigation-module__Tlm5cW__navAnimation",
  "scaleOrigin": "TopNavigation-module__Tlm5cW__scaleOrigin",
  "slideIn": "TopNavigation-module__Tlm5cW__slideIn",
});
